import { render, staticRenderFns } from "./Report2.vue?vue&type=template&id=7fb815c6"
import script from "./Report2.vue?vue&type=script&lang=js"
export * from "./Report2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports